

export default{
    //企业年限
    year:"16",
    studentNum:"350万+",
    serviceNum:"2600+",
    patentNum:"25",
    softwareNum:"47"
}